import Principal from '../../core/layouts/Principal.vue';
import Manage from './views/Manage.vue';
import List from './views/List.vue';

window.routes.push({
  path: '/templates',
  name: 'templates',
  component: Principal,
  children: [
    {
      path: 'manage/:id?',
      name: 'manage',
      component: Manage,
    },
    {
      path: 'list',
      name: 'list',
      component: List,
    }
  ],
});